import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { BLESSING_STAT, BLESSING_DIRECTION, BLESSING_TARGET } from '../../enum-registry.ts';

export const DegenRunePoolSchema = defineSchema({
  name: 'serverDegenRunePool',
  fields: [
    ['id', 'string'],
    ['stat', { kind: 'enum', name: 'BlessingStat', members: BLESSING_STAT }],
    ['direction', { kind: 'enum', name: 'BlessingDirection', members: BLESSING_DIRECTION }],
    ['target', { kind: 'enum', name: 'BlessingTarget', members: BLESSING_TARGET }],
    ['value', 'number'],
    ['weight', 'number'],
    ['selectionWeight', 'number'],
  ],
  lookupKeys: ['id'],
});

export interface RawDegenRunePoolRow {
  id: string;
  stat: string;
  direction: string;
  target: string;
  value: number;
  weight: number;
  selection_weight: number;
}

export function degenRunePoolFromRaw(row: RawDegenRunePoolRow) {
  return {
    id: row.id,
    stat: row.stat,
    direction: row.direction,
    target: row.target,
    value: row.value,
    weight: row.weight,
    selectionWeight: row.selection_weight,
  };
}

registerCategorySchema('serverDegenRunePool', DegenRunePoolSchema);
